module.exports = __webpack_public_path__ + "static/img/wisc.74a705d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisc.png
// module id = Jheo
// module chunks = 1